






import { Component, Vue } from "vue-property-decorator";
import PanelComponent from "./Panel.vue";
import { mapState } from 'vuex'

@Component({
    components: {
       PanelComponent
    },    
      computed: {
        ...mapState(['panels'])
    },
})
export default class PanelsComponent extends Vue {
}
